import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Linkedin } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-midnight border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="max-w-sm">
            <Logo imgClassName="h-20 w-auto" />
            <p className="mt-4 font-display font-bold text-amber text-lg">Your Mind, Multiplied.</p>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">
              Practical thinking about artificial intelligence, people, and better ways of working.
            </p>
            <p className="mt-3 text-sm text-slate-500">Wisconsin</p>
          </div>

          <div className="flex gap-14">
            <div>
              <h4 className="text-white text-sm font-semibold mb-4">Explore</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li><Link to="/field-notes" className="hover:text-amber transition-colors" data-testid="footer-link-field-notes">Field Notes</Link></li>
                <li><Link to="/our-approach" className="hover:text-amber transition-colors" data-testid="footer-link-our-approach">Our Approach</Link></li>
                <li><Link to="/about" className="hover:text-amber transition-colors" data-testid="footer-link-about">About</Link></li>
                <li><Link to="/contact" className="hover:text-amber transition-colors" data-testid="footer-link-contact">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-sm font-semibold mb-4">Get in touch</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li><a href="mailto:chris.dean@symbicognitive.com" className="hover:text-amber transition-colors">chris.dean@symbicognitive.com</a></li>
                <li><a href="tel:7153794991" className="hover:text-amber transition-colors">715-379-4991</a></li>
                <li><a href="https://linkedin.com/in/crdean" target="_blank" rel="noopener noreferrer" className="hover:text-amber transition-colors">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {year} SymbiCognitive. All rights reserved. SymbiCognitive is a developing project.</p>
          <a
            href="https://linkedin.com/in/crdean"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="h-9 w-9 rounded-lg bg-white/5 grid place-items-center text-slate-400 hover:bg-amber hover:text-midnight transition-colors"
            aria-label="LinkedIn"
          >
            <Linkedin size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
